import { Box } from "@mui/material";
import Lottie from "lottie-react";
import { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import LoadingAnimation from "src/assets/json/loading.json";
const Loader = () => {
  return (
    <>
      <Helmet>
        <title>Marketaria</title>
      </Helmet>
      <Fragment>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
        >
          <Lottie
            style={{
              width: 110,
              height: 110,
            }}
            animationData={LoadingAnimation}
            loop={true}
          />
        </Box>
      </Fragment>
    </>
  );
};

export default Loader;
